"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AprendaComProjetos = function AprendaComProjetos() {
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1044 999"
  }, _react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h1044v999H0z"
  }), _react.default.createElement("path", {
    fill: "#242523",
    d: "M904.64 699.48h-19.85V297.72a48.34 48.34 0 00-48.28-48.28H208.49a48.34 48.34 0 00-48.28 48.28v401.76h-19.85c-7 0-12.67 5.67-12.67 12.67v34.83A41.07 41.07 0 00168.7 788h707.58a41.07 41.07 0 0041.02-41.02v-34.83c0-7-5.67-12.67-12.67-12.67zM185.56 297.72a22.96 22.96 0 0122.93-22.93H836.5a22.96 22.96 0 0122.94 22.93v401.76H185.56V297.72zm299.76 427.11h74.36v6.63a5.39 5.39 0 01-5.38 5.38h-63.6a5.39 5.39 0 01-5.38-5.38v-6.63zm406.64 22.15c0 8.64-7.03 15.67-15.67 15.67H168.71a15.69 15.69 0 01-15.67-15.67v-22.15h315.38v6.63a22.3 22.3 0 0022.28 22.28h63.6a22.3 22.3 0 0022.29-22.28v-6.63h315.36v22.15z"
  }), _react.default.createElement("path", {
    fill: "#63DC3E",
    fillRule: "evenodd",
    d: "M359.75 85.29c39.53-39.54 92.08-61.23 147.97-61.23A208.1 208.1 0 01655.7 85.41 207.89 207.89 0 01717 233.33c0 55.9-21.75 108.38-61.29 147.91a209.43 209.43 0 01-87.68 52.49c-4.96 26.9-17.79 52.24-35.94 70.4a99.5 99.5 0 01-11.28 9.66 19.43 19.43 0 01-23.11-.06 19.59 19.59 0 01-6.88-22c4.52-13.2 3.28-30.05-3.66-50.25-106.4-10.35-188.63-100.4-188.63-208.22 0-55.89 21.69-108.44 61.23-147.97z",
    clipRule: "evenodd"
  }), _react.default.createElement("path", {
    fill: "#242523",
    d: "M661.1 169.28l-120.97-62.8a8.56 8.56 0 00-7.89 0l-120.97 62.8a8.56 8.56 0 00-4.61 7.6v32.77a8.56 8.56 0 0017.12 0v-18.69l18.34 9.53v68.16c0 1.79.56 3.53 1.6 4.98.9 1.25 22.6 30.48 92.47 30.48 69.86 0 91.57-29.24 92.46-30.48a8.56 8.56 0 001.6-4.98V200.5l30.85-16.02a8.56 8.56 0 000-15.2zm-47.98 96.07c-5.68 5.46-26.76 21.64-76.93 21.64-50.18 0-71.26-16.18-76.95-21.64v-55.98l73 37.9a8.54 8.54 0 007.89 0l73-37.9v55.98zm-76.93-35.33l-102.4-53.15 102.4-53.15 102.39 53.15-102.4 53.16z"
  }), _react.default.createElement("path", {
    fill: "#242523",
    d: "M415.22 225.76a8.56 8.56 0 00-8.56 8.56v10.35a8.56 8.56 0 0017.12 0v-10.35a8.56 8.56 0 00-8.56-8.56z"
  }), _react.default.createElement("path", {
    fill: "#242523",
    d: "M536.1-4.3c-55.9 0-108.45 21.68-147.98 61.22-39.54 39.53-61.23 92.08-61.23 147.97 0 107.83 82.23 197.87 188.63 208.22 6.94 20.2 8.18 37.05 3.66 50.25a19.59 19.59 0 006.88 22 19.43 19.43 0 0023.1.06 99.61 99.61 0 0011.29-9.67c18.15-18.15 30.98-43.5 35.94-70.4a209.44 209.44 0 0087.68-52.48 207.74 207.74 0 0061.29-147.91c0-55.9-21.81-108.45-61.29-147.92A208.1 208.1 0 00536.1-4.31zm185.52 209.2c0 49.57-19.33 96.17-54.34 131.18a185.5 185.5 0 01-84.46 48.4 12.24 12.24 0 00-5.4 3.03 12.32 12.32 0 00-3.4 6.88c-4.28 33.65-21.2 54.9-29.37 63.46 2.54-17.42-.62-37.3-9.67-60.36a11.91 11.91 0 00-10.35-7.5c-97.66-5.95-174.2-87.31-174.2-185.22 0-49.57 19.34-96.17 54.36-131.19a184.35 184.35 0 01131.18-54.34c102.43.06 185.72 83.34 185.65 185.65z"
  }), _react.default.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M169.72 788h703.5L1044 999H0l169.72-211z"
  }), _react.default.createElement("defs", null, _react.default.createElement("linearGradient", {
    id: "paint0_linear",
    x1: "522",
    x2: "522",
    y1: "745.77",
    y2: "999",
    gradientUnits: "userSpaceOnUse"
  }, _react.default.createElement("stop", {
    stopColor: "#F2F2F2"
  }), _react.default.createElement("stop", {
    offset: "0.58",
    stopColor: "#fff",
    stopOpacity: "0"
  }))));
};

var _default = AprendaComProjetos;
exports.default = _default;